import { render, staticRenderFns } from "./docker.vue?vue&type=template&id=50577a6c&"
var script = {}
import style0 from "./docker.vue?vue&type=style&index=0&id=50577a6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports